import { render, staticRenderFns } from "./OccupationToolPage.vue?vue&type=template&id=37a0d440&scoped=true&"
import script from "./OccupationToolPage.vue?vue&type=script&lang=js&"
export * from "./OccupationToolPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a0d440",
  null
  
)

export default component.exports